import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { CreateProjectService } from '@app/shared/services/create-project/create-project.service';
import { ScheduleCallComponent } from '@app/shared/components/schedule-call/schedule-call.component';
import { EBSUser } from '@app/shared/models/ebs-user';
import { ServiceProvider } from '@app/shared/models/service-provider.model';
import { AuthenticationService } from '@app/shared/services/authentication.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-analyst',
  templateUrl: './analyst.component.html',
  styleUrls: ['./analyst.component.css']
})
export class AnalystComponent implements OnInit,OnDestroy {
  //  @ViewChild('LinkShareModal', { static: false }) linkShare: LinkShareComponent;
  @ViewChild(ScheduleCallComponent) scheduleCallModal: ScheduleCallComponent;
  @Output() selectedAnalyst: EventEmitter<any> = new EventEmitter<any>();
  @Output() deleteAnalyst: EventEmitter<any> = new EventEmitter<any>();

  @Input() serviceProvider: any;
  @Input() rating: any;
  @Input() price: any;
  isUserSignedIn: boolean;
  userSignInSubscription$: Subscription;
  currentUser: any;
  public modalRef: BsModalRef;
  selectedItemsList = [];

  //See more checkboxes
  showMoreServices = false;
  showMoreMarkets = false;
  showMoreIndustries = false;
  showMoreFocusAreas = false;
  
  constructor(
    private router: Router,
    private authService: AuthenticationService,
    private createProjectService: CreateProjectService,
  ) {
  }

  ngOnInit() {
    this.userSignInSubscription$ = this.authService.currentEBSUser.subscribe(
      (userData: EBSUser) => {
        this.isUserSignedIn = userData.id ? true : false;
        if (this.isUserSignedIn) {
          this.currentUser = userData;
        }
      }
    );
    this.formatResultantList();
    this.clearSelectedSPData();

  }
  ngOnDestroy() {
    this.userSignInSubscription$.unsubscribe();
  }

  navigateToLogin() {
    this.router.navigateByUrl('/login');
  }

  navigateToProfile(profileData: ServiceProvider) {
      this.router.navigate(['analyst-profile'], { queryParams: { analystId: profileData.id } });
  }

  clearSelectedSPData() {
    this.createProjectService.clearServiceProviderInfo();
  }

  onRequestQuote() {
    this.createProjectService.setNormalMode();
    const serviceProviderList = [this.serviceProvider];
    this.createProjectService.setAccountType('service_provider');
    this.createProjectService.setServiceProviderInfo(serviceProviderList);
    this.router.navigateByUrl('/project-form-common');
  }

  // showShareModal(type,item) {
  //   if (this.isUserSignedIn) {
  //     this.linkShare.showModal(type,item);
  //   } else {
  //     this.redirectToLogin();
  //   }
  // }

  redirectToLogin() {
    this.router.navigateByUrl('/login');
  }

  public updateSelectedList(itemData) {
    this.selectedAnalyst.emit(itemData);
  }

  public formatResultantList() {
    // Compare the item with the selectedArray, if present, set the selected status to true
    this.serviceProvider.isSelected = this.checkSelectionStatus(this.serviceProvider);
  }

  public checkSelectionStatus(refData) {
    let isSelected = false;
    const resItem = this.selectedItemsList.find((item) => {
      return item.id == refData.id;
    });
    if (resItem) {
      isSelected = true;
    }
    return isSelected;
  }

  public removeFromSelectedItems(deletedItemId) {
    this.deleteAnalyst.emit(deletedItemId);
  }

  seeMoreValues(offerings,event) {
    switch (offerings) {
      case 'service':
        this.showMoreServices = event;
        break;
      case 'market':
        this.showMoreMarkets = event;
        break;
      case 'industry':
        this.showMoreIndustries = event;
        break;
      case 'focusArea':
        this.showMoreFocusAreas = event;
        break;
      default:
        break;
    }
  }

  bookACall() {
    this.scheduleCallModal.showModal(this.serviceProvider.id, this.serviceProvider.name);
  }
}



// WEBPACK FOOTER //
// ./src/app/feature/main/roles-shared/components/analyst-search/analyst-search-results/analyst/analyst.component.ts